import { Box, Stack } from '@mui/material';
import type { DocumentItemStatusLight } from 'lib/mobileDesignSystem';
import {
  BackBubbleButton,
  ContentCard,
  DocumentItem,
  ErrorState,
  HeroHeader,
  TabContentSkeleton,
} from 'lib/mobileDesignSystem';
import React from 'react';

export interface DocumentPageItem {
  key: string;
  primaryText: string;
  secondaryText?: string;
  amount: string | number;
  statusLights?: DocumentItemStatusLight[];
}

export interface SharedDocumentsPageProps {
  isLoading: boolean;
  isError: boolean;
  notFound: boolean;
  documentItems: DocumentPageItem[];
  onBack: () => void;
}

const SharedDocumentsPage: React.FC<SharedDocumentsPageProps> = ({
  isLoading,
  isError,
  notFound,
  documentItems,
  onBack,
}) => {
  if (isLoading) {
    return <TabContentSkeleton />;
  }

  if (isError) {
    return <ErrorState message="Ocurrió un error al cargar los documentos." />;
  }

  if (notFound) {
    return <ErrorState message="No se encontró la operación." />;
  }

  return (
    <Stack
      sx={{ position: 'relative', flex: 1, minHeight: '100%', px: 0 }}
      spacing={0}
    >
      <Box sx={{ position: 'relative', flexShrink: 0 }}>
        <HeroHeader
          title="Documentos"
          minHeight={60}
          sx={{ width: '100vw', mx: 'calc(-50vw + 50%)' }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            pt: 0.5,
            px: 2,
          }}
        >
          <BackBubbleButton onClick={onBack} />
        </Box>
      </Box>
      <Stack spacing={2} sx={{ px: 2, pt: 2 }}>
        <ContentCard>
          <Stack spacing={0} direction="column">
            {documentItems.map((item) => (
              <DocumentItem
                key={item.key}
                primaryText={item.primaryText}
                secondaryText={item.secondaryText}
                amount={item.amount}
                statusLights={item.statusLights}
              />
            ))}
          </Stack>
        </ContentCard>
      </Stack>
    </Stack>
  );
};

export default SharedDocumentsPage;
